"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinoMethodByLogLevel = exports.LogLevel = void 0;
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["Trace"] = 10] = "Trace";
    LogLevel[LogLevel["Debug"] = 20] = "Debug";
    LogLevel[LogLevel["Info"] = 30] = "Info";
    LogLevel[LogLevel["Warn"] = 40] = "Warn";
    LogLevel[LogLevel["Error"] = 50] = "Error";
    LogLevel[LogLevel["Fatal"] = 60] = "Fatal";
})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
exports.PinoMethodByLogLevel = Object.freeze({
    [LogLevel.Trace]: 'trace',
    [LogLevel.Debug]: 'debug',
    [LogLevel.Info]: 'info',
    [LogLevel.Warn]: 'warn',
    [LogLevel.Error]: 'error',
    [LogLevel.Fatal]: 'fatal',
});
//# sourceMappingURL=relayed-logger-interface.js.map